/* eslint-disable arrow-body-style */
import { AGGREGATION_RULES } from './static_data';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import {
  METRICS_TIPS_EN,
  METRICS_TIPS_CN,
  METRICS_CALC_METHODS_TIPS_EN,
  METRICS_CALC_METHODS_TIPS_CN,
} from '../constants';

import type { FormatMessageOptionType } from '@/pages/home/components/NewRegionSelect/useLocale';
// @ts-ignore

const getMetricsTips = (
  locale: string,
): {
  [key: string]: string;
} => {
  return locale === LANGUAGE_CN ? METRICS_TIPS_CN : METRICS_TIPS_EN;
};

const getMetricsCalcMethodsTips = (
  locale: string,
): {
  [key: string]: string;
} => {
  return locale === LANGUAGE_CN ? METRICS_CALC_METHODS_TIPS_CN : METRICS_CALC_METHODS_TIPS_EN;
};

/**
 * 获取聚合的提示文本
 * @param type 游戏类型
 * @param market 指标名
 * @param platform 平台
 * @returns 提示内容
 */
export const getAggregationTipContent = (type: string, market: string, platform: string) => {
  // 把类型，指标，平台拼接成对应的key
  let key = `${type.trim().replace(/\s+/g, '-')}_${market.trim().replace(/\s+/g, '-')}_${platform.trim().replace(/\s+/g, '-')}`;

  // console.log('keykeykeykey',key);

  if (!AGGREGATION_RULES[key]) return '';

  switch (key) {
    case 'Mobile_RPD_Appannie':
      return 'Take the cumulative revenue divided by cumulative downloads in selected time interval.';

    case 'PC_Digital-AST_MScience':
      return 'AST is Average Spending per Transaction. Take the WEIGHTED AVG value in selected time interval.';

    case 'PC_ACU_Steam':
      return 'ACU is the AVG Concurrent User. Take the AVG value in selected time interval.';

    case 'PC_Acquisitions%_Newzoo':
      return 'Acquisitions% is the percentage of players acquired by the game among all players of the genre. Take the WEIGHTED AVG value in selected time interval.';

    case 'Console_Sales-of-selected-time_famitsu':
      return 'Sales of selected time';

    case 'Console_Cumulative-Sales-of-the-latest-week_famitsu':
      return 'Cumulative Sales of the latest week';

    case 'Console_Cumulative-Revenue-of-the-latest-week($)_famitsu':
      return 'Cumulative Revenue of the latest week($)';

    case 'Console_Digital-AST_MScience':
      return 'AST is Average Spending per Transaction. Take the WEIGHTED AVG value in selected time interval.';

    case 'Console_Acquisitions%_Newzoo':
      return 'Acquisitions% is the percentage of players acquired by the game among all players of the genre. Take the WEIGHTED AVG value in selected time interval.';

    case 'Streaming_Peak-CCV_Stream-Hatchet':
    case 'Mobile_Peak-CCV_Stream-Hatchet':
    case 'PC_Peak-CCV_Stream-Hatchet':
    case 'Console_Peak-CCV_Stream-Hatchet':
    case 'Combine_Peak-CCV_Stream-Hatchet':
      return 'Here shows the peak number of concurrent viewership. Take the MAX value of selected time interval.';

    case 'Mobile_Retention-D2_':
    case 'Mobile_Retention-D2_Appannie':
      return 'Take the AVG Retention-D2 in selected time interval and valid country range.';
    //   revenue特殊说明
    case 'Mobile_Revenue_Appannie':
    case 'Mobile_Revenue_SensorTower':
    case 'Mobile_Revenue_DataBrain':
      return (
        `<p>Take the ${AGGREGATION_RULES[key]} value in selected time interval.</p>
            <p> Revenue has removed 30% commission from in-app purchases, subscriptions and paid app downloads.</p>`
      )
    case 'Mobile_D2_Appannie':
      return `Percentage of users who opened the app again on the 2nd day after first time the app was launched by users. `
    case 'Mobile_D3_Appannie':
      return `Percentage of users who opened the app again on the 3rd day after first time the app was launched by users.`
    case 'Mobile_D7_Appannie':
      return `Percentage of users who opened the app again on the 7th day after first time the app was launched by users.`
    case 'Mobile_D15_Appannie':
      return `
        <p>Percentage of users who opened the app again on the 15th day after first time the app was launched by users.</p>
        <p>data.ai can only provide the retention data on the 15th day, so there is no Annie D14 (双周留存) .</P>
        `
    case 'Mobile_D31_Appannie':
      return `
        <p>Percentage of users who opened the app again on the 31st day after first time the app was launched by users.</p>
        <P>data.ai can only provide the retention data on the 31st day, so there is no Annie D30 (月留存) .</P>
        `
    case 'PC_Digital-Units_MScience':
    case 'Console_Digital-Units_MScience':
      return `"Units" indicates the number of orders, units of segment "All" is reasonably smaller than the sum units of other segments. Since one single order might include base game and DLC, etc. Take the SUM value with selected countries.`

    case 'Combine_Sales-of-the-Latest-Week_famitsu':
      return 'Sales of the Latest Week';
    case 'Combine_Revenue-of-the-Latest-Week_famitsu':
      return 'Revenue of the Latest Week';
    // case 'Sales of selected time':
    default:
      return `Take the ${AGGREGATION_RULES[key]} value in selected time interval.`
  }
}

export const getAggregationTipContentNew = (cfg: {
  type: string;
  market: string;
  platform: string;
  locale: string;
  formatMessage: (payload: FormatMessageOptionType) => string;
}): string => {
  const { type, market, platform, locale, formatMessage } = cfg || {};
  const key = `${type.trim().replace(/\s+/g, '-')}_${market.trim().replace(/\s+/g, '-')}_${platform.trim().replace(/\s+/g, '-')}`;
  const metricsTips = getMetricsTips(locale);
  const metricTip = metricsTips[key];
  // 能在中英文配置里匹配上，直接返回中英文配置中的文案
  if (metricTip) return metricTip;

  // 无法通过中英文配置实现翻译，需要代码组装文案
  if (!AGGREGATION_RULES[key]) return '';
  const metricsCalcMethodsTips = getMetricsCalcMethodsTips(locale);
  let metricCalcMethodTips = `Take the ${AGGREGATION_RULES[key]} value in selected time interval.`;
  metricCalcMethodTips = metricsCalcMethodsTips[metricCalcMethodTips] || metricCalcMethodTips;
  // 原getAggregationTipContent方法中 switch-case 的default逻辑
  if (!['Mobile_Revenue_Appannie', 'Mobile_Revenue_SensorTower', 'Mobile_Revenue_DataBrain'].includes(key)) {
    return metricCalcMethodTips;
  }
  // 原原getAggregationTipContent方法中 'Mobile_Revenue_Appannie', 'Mobile_Revenue_SensorTower', 'Mobile_Revenue_DataBrain' 的逻辑
  return `
    <p>${metricCalcMethodTips}</p>
    <p>${formatMessage({ id: 'dbi_info_revenue_removed_new' })}</p>
  `;
};

/**
 * Ranking数据源，获取数据地图对应指标的英文解释
 * @param gameType 游戏类型
 * @param metricName 指标名称
 * @param dataSource 数据源
 * return 英文注解
 */
export const getDataMapMetricsEnInfo = (gameType: string, metricName: string, dataSource: string) => {
  // const resultItem = intelligenceMetricsData?.filter((t: any) => (
  //   (t?.sourceType === (gameType + ' Game')) &&
  //   (t?.metriceName === metricName) &&
  //   (t?.dataSource === dataSource))
  // );

  // return resultItem?.[0]?.remarks?.split('\n')?.[0] || resultItem?.[0]?.remarks || '';
}
